import { DimensionValue } from "../../shared/models/catalog.model";

// Browser copy of the loader's dimension fold (server: tracked_data/services/dimension_values.py,
// DimensionValueNormalizer.normalize): trim and lowercase the cell, then exact-match it against a
// value's code or any of its aliases. Never fuzzy, never prefix. The editor uses it only to SHOW
// ops what a cell would fold to (MPN-2310); the loader's copy is the one that writes data. If the
// rule changes there, change it here.
export function foldDimensionValue(raw: string, values: DimensionValue[]): DimensionValue | null {
  const token = raw.trim().toLowerCase();
  if (!token) return null;
  for (const v of values) {
    if (v.code.trim().toLowerCase() === token) return v;
    if ((v.aliases ?? []).some((a) => a.trim().toLowerCase() === token)) return v;
  }
  return null;
}

// One line naming where a column-sourced dimension can land, so the field map row says
// "folds to Math or English" instead of leaving the targets two pages away in the catalog.
export function foldTargetsLine(axis: string, values: DimensionValue[]): string {
  if (values.length === 0) {
    return `The catalog has no ${axis} values yet, so each cell is stored as-is.`;
  }
  const shown = values.slice(0, 4).map((v) => {
    const n = (v.aliases ?? []).length;
    return `${v.name || v.code} (${n} alias${n === 1 ? "" : "es"})`;
  });
  const more = values.length - shown.length;
  const targets = more > 0 ? `${shown.join(", ")} or ${more} more` : shown.join(" or ");
  return `Each cell folds to ${targets} through the catalog aliases. Anything else is stored as-is and matches no rule.`;
}
